export enum URLTargetType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
  CUSTOM_URL = 'custom_url',
  FILE = 'file',
}
